export const leerklimaatCultiveren = {
  DATAGEBRUIK_ONDERSTEUNEN: 'DATAGEBRUIK_ONDERSTEUNEN',
  INSPRAAK_GEVEN: 'INSPRAAK_GEVEN',
  INTELLECTUEEL_UITDAGEN: 'INTELLECTUEEL_UITDAGEN',
  POSITVITEIT_BEVORDEREN: 'POSITVITEIT_BEVORDEREN',
  SAMEN_LEREN_ONDERSTEUNEN: 'SAMEN_LEREN_ONDERSTEUNEN',
  VERANDERING_FACILITEREN: 'VERANDERING_FACILITEREN',
}

export const onderwijskwaliteitVersterken = {
  AANDACHT_GEVEN: 'AANDACHT_GEVEN',
  AANWEZIG_ZIJN: 'AANWEZIG_ZIJN',
  GEDRAGEN_COMMUNICATEREGELS_INSTALLEREN: 'GEDRAGEN_COMMUNICATEREGELS_INSTALLEREN',
  HELDERE_STRUCTUUR_EN_PROCEDURES_ONTWERPEN: 'HELDERE_STRUCTUUR_EN_PROCEDURES_ONTWERPEN',
  DOELTREFEND_PERSONEELSBELEID_VOEREN: 'DOELTREFEND_PERSONEELSBELEID_VOEREN',
  GEPASTE_INFRASTRUCTUUR_EN_MATERIALEN_VOORZIEN: 'GEPASTE_INFRASTRUCTUUR_EN_MATERIALEN_VOORZIEN',
  FINANCIELE_MIDDELEN_BEHEREN: 'FINANCIELE_MIDDELEN_BEHEREN',
  FUNCTONELE_EXTERNE_RELATES_ONDERHOUDEN: 'FUNCTONELE_EXTERNE_RELATES_ONDERHOUDEN',
}

export const ondewijsambitieRealiseren = {
  GERICHT_ZIJN_OP_VISIE_EN_DOELEN: 'GERICHT_ZIJN_OP_VISIE_EN_DOELEN',
  INSPIREREN_TOT_EFECTEF_ONDERWIJS: 'INSPIREREN_TOT_EFECTEF_ONDERWIJS',
  BETROKKEN_ZIJN_OP_LESGEVEN_EN_EVALUEREN: 'BETROKKEN_ZIJN_OP_LESGEVEN_EN_EVALUEREN',
  OPVOLGEN_REALISATE_ONDERWIJSDOELEN_EN_TERUGKOPPELEN:
    'OPVOLGEN_REALISATE_ONDERWIJSDOELEN_EN_TERUGKOPPELEN',
  RESULTAATGERICHT_WAARDEREN: 'RESULTAATGERICHT_WAARDEREN',
  GEDRAGEN_VISIE_EN_DOELEN_ONTWIKKELEN: 'GEDRAGEN_VISIE_EN_DOELEN_ONTWIKKELEN',
}
